import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const sharedData: Pick<LocDef, 'feature' | 'type' | 'portal' | 'htmlAllowed' | 'shared'> = {
	feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
	portal: 'CP',
	htmlAllowed: false,
	shared: false,
};

const dpRoot = 'Profile|Affiliation';

export type CpProfileAffiliationFormLocs =
	| 'CPProfileAffiliationRequired'
	| 'CPProfileAffiliationSectionTitle';
export type CpProfileAffFormLocsType = LocMap<CpProfileAffiliationFormLocs>;

// The first localization includes multiple legacyName properties (commented) as they are being removed later.
export const cpProfileAffiliationFormLocs: LocDefs<CpProfileAffiliationFormLocs> = {
	CPProfileAffiliationRequired: {
		...sharedData,
		defaultValue:
			'You are missing an affiliation and it must be added before continuing to use this site.',
		displayPath: 'System|Prerequisite|Add Affiliation Requirement',
		description:
			"A notice that the candidate's affiliation must be added before the candidate can do anything else in the system",
		htmlAllowed: true,
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliationRequired,
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation.Required/System.Prerequisite.AffiliationInfoUpdateRequired',
		displayType: 'Content',
		// legacyName: 'CandidateProfile.PrimaryInformation.Affiliation/Profile.Affiliation.Button.ClearButton'
	},
	CPProfileAffiliationSectionTitle: {
		...sharedData,
		defaultValue: 'Personal Information',
		description: 'Title for the affiliation section.',
		displayPath: `${dpRoot}|Affiliation Section`,
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Profile.Affiliation.Title.PersonalInformation',
		displayType: 'Title',
	},
};

export const CpProfileAffFormLocs = MapLocKeys<CpProfileAffiliationFormLocs>(
	cpProfileAffiliationFormLocs
);
